import { NonemptyPartial, PillColor } from '@aiwyn/shared';
import { ClientRequestGroupJobModel, ClientRequestGroupModel, ClientRequestGroupType } from '@aiwyn/api';
import { BaseContact } from '@aiwyn/shared';

export type ClientRequestGroupIds = NonemptyPartial<RawClientRequestGroupIds>;

export type TypedIdentity<Type extends string = string> = `${Type}-${number}`;

interface RawClientRequestGroupIds {
  jobIds: number[];
  engagementIds: number[];
  ungrouped: true; // Not provided means exclude ungrouped
}

export type CommonClientRequestGroupIdentityToModelMap<Identity extends TypedIdentity<ClientRequestGroupType>> =
  Identity extends TypedIdentity<ClientRequestGroupType.JOB>
    ? ClientRequestGroupJobModel
    : ClientRequestGroupModel;

export type ClientRequestAssigneeModel = BaseContact; // BaseInvitee;

export enum ClientRequestGroupStatus {
  OPEN = 'Open',
  COMPLETED = 'Completed',
}

export interface ClientRequestStatusPill {
  status: ClientRequestStatusPillEnum;
  color: PillColor;
}

export enum ClientRequestStatusPillEnum {
  NOT_STARTED = 'Not Started',
  IN_PROGRESS = 'In Progress',
  IN_REVIEW = 'In Review',
  DONE = 'Done'
}
